export default "__VITE_ASSET__BdZ4bcvo__"